import Image from 'next/image';

type LogoVariant = 'icon' | 'icon-dark' | 'wordmark' | 'combined-horizontal' | 'combined-stacked';
type LogoSize = 'sm' | 'md' | 'lg';

interface LogoProps {
  variant?: LogoVariant;
  size?: LogoSize;
  className?: string;
}

const logoFiles: Record<LogoVariant, string> = {
  'icon': '/images/guardian-icon-light.svg',
  'icon-dark': '/images/guardian-icon-dark.svg',
  'wordmark': '/images/guardian-wordmark-light.svg',
  'combined-horizontal': '/images/guardian-combined-horizontal-light.svg',
  'combined-stacked': '/images/guardian-combined-stacked-light.svg',
};

const logoSizes: Record<LogoVariant, Record<LogoSize, { width: number; height: number }>> = {
  'icon': {
    sm: { width: 32, height: 32 },
    md: { width: 40, height: 40 },
    lg: { width: 56, height: 56 },
  },
  'icon-dark': {
    sm: { width: 32, height: 32 },
    md: { width: 40, height: 40 },
    lg: { width: 56, height: 56 },
  },
  'wordmark': {
    sm: { width: 80, height: 24 },
    md: { width: 120, height: 36 },
    lg: { width: 160, height: 48 },
  },
  'combined-horizontal': {
    sm: { width: 120, height: 32 },
    md: { width: 160, height: 42 },
    lg: { width: 200, height: 52 },
  },
  'combined-stacked': {
    sm: { width: 80, height: 72 },
    md: { width: 120, height: 108 },
    lg: { width: 160, height: 144 },
  },
};

export function Logo({
  variant = 'icon',
  size = 'md',
  className = '',
}: LogoProps) {
  const src = logoFiles[variant];
  const { width, height } = logoSizes[variant][size];

  return (
    <Image
      src={src}
      alt="Vetta"
      width={width}
      height={height}
      className={className}
      priority
    />
  );
}
